// extracted by mini-css-extract-plugin
export default {"container":"Footer_container__LEy6Q","link":"Footer_link__SJ1M6","linkedIn":"Footer_linkedIn__OyIJ9","github":"Footer_github__5opum"};